module.exports = __webpack_public_path__ + "static/NoKidHungry-b6f0b147fa339133e282abfb8093fa17.png";